import { WizardItem } from '../../../types/wizard';

export interface ActiveItem {
  id: string;
  title: string;
  answers: string[];
}

const getActiveItemRecursively = (
  item: WizardItem,
  collectedItems?: ActiveItem[]
): ActiveItem[] => {
  // Are there active items inside the item?
  const activeOptions = item.items.filter((data) => data.value);
  const itemAccumulator = [...(collectedItems || [])];

  // When active item is found, store the item in the accumulator.
  if (activeOptions.length) {
    itemAccumulator.push({
      id: item.id,
      title: item.title || '',
      answers: activeOptions.map((data) => data.title || ''),
    });
  }

  // When the item has items, loop trough those items as well.
  if (item.items.length) {
    return item.items
      .map((data) => getActiveItemRecursively(data, itemAccumulator))
      .flat();
  }

  return itemAccumulator;
};

// Get all active selected items, data passed is from the wizard store.
export const getActiveItems = (items: WizardItem[]): ActiveItem[] => {
  const activeItems = items
    .map((item) => getActiveItemRecursively(item))
    .flat();

  return [...new Map(activeItems.map((item) => [item.id, item])).values()];
};
